import React from "react";
import type { Editor } from "@tiptap/react";
import { Button } from "@/components/ui/button";
import { AlignLeft, AlignCenter, AlignRight } from "lucide-react";

interface AlignmentGroupProps {
  editor: Editor;
  disabled: boolean;
  onSetAlignment: (alignment: string) => void;
}

export function AlignmentGroup({ editor, disabled, onSetAlignment }: AlignmentGroupProps) {
  return (
    <>
      <Button
        type="button"
        variant={editor.isActive({ textAlign: "left" }) ? "default" : "ghost"}
        size="sm"
        onClick={() => onSetAlignment("left")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Align Left"
      >
        <AlignLeft className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant={editor.isActive({ textAlign: "center" }) ? "default" : "ghost"}
        size="sm"
        onClick={() => onSetAlignment("center")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Align Center"
      >
        <AlignCenter className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant={editor.isActive({ textAlign: "right" }) ? "default" : "ghost"}
        size="sm"
        onClick={() => onSetAlignment("right")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Align Right"
      >
        <AlignRight className="h-4 w-4" />
      </Button>
    </>
  );
}
